import * as PIXI from "pixi.js";
import PixiCard from "./PixiCard";

const TWEEN = require('@tweenjs/tween.js');

interface IState {
    scale?: number;
    x: number;
    y: number;
}

const E_NONE = TWEEN.Easing.Linear.None;
const E_OUT  = TWEEN.Easing.Cubic.Out;
const E_EL_OUT  = TWEEN.Easing.Elastic.Out;

export default class Tweener {
    private item: PIXI.Container;
    private isFlipping = false;
    private isTweening = false;
    private callbacks:Array<()=>void> = [];

    constructor(item: PIXI.Container) {
        this.item = item;
    }

    public get flipping() {
        return this.isFlipping;
    }

    public get tweening() {
        return this.isTweening;
    }

    public addCallback(cb: ()=>void) {
        this.callbacks.push(cb);
    }

    /**
     * Карта в руке: перейти в новое состояние
     */
    public addTween(state: IState, duration: number, cb?: ()=>void) {
        this.isTweening = true;
        if (state.scale) {
            new TWEEN.Tween(this.item.scale)
                .to({
                    x: state.scale,
                    y: state.scale,
                }, duration)
                .easing(E_NONE)
                .start();
        }
        new TWEEN.Tween(this.item)
            .to({
                x: state.x,
                y: state.y,
            }, duration)
            .easing(E_NONE)
            .onComplete(() => {
                this.isTweening = false;
                cb?.();
                while (this.callbacks.length) {
                    const nextCallback = this.callbacks.pop();
                    nextCallback?.();
                }
            })
            .start();
    }


    /**
     * Анимация перемешивания пачки
     */
    public addShuffleTween(): void
    {
        this.isTweening = true;
        const kScale = 1.1;
        let scaleX = this.item.scale.x, scaleY = this.item.scale.y;
        this.item.scale.x = scaleX * kScale;
        this.item.scale.y = scaleY / kScale;
        new TWEEN.Tween(this.item.scale)
            .to({ x: scaleX / kScale, y: scaleY * kScale }, 50)
            .easing(TWEEN.Easing.Elastic.Out)
            .repeat(8)
            .yoyo(true)
            .onComplete(() => {
                this.item.scale.x = scaleX;
                this.item.scale.y = scaleY;
                this.isTweening = false;
            })
            .start();
    }

    /**
     * Анимация неверного хода
     */
    public addWrongMoveTween(state: IState, duration: number, cb?: ()=>void): void
    {
        new TWEEN.Tween(this.item)
            .to({
                x: state.x,
                y: state.y,
            }, duration)
            .easing(E_EL_OUT)
            .onComplete(() => {
                this.isTweening = false;
                cb?.();
            })
            .start();
    }

    public addFlipTween(width: number, duration: number, cb?: ()=>void) {
        this.isFlipping = true;
        new TWEEN.Tween((this.item as PixiCard).art)
            .to({ width }, duration)
            .easing(E_NONE)
            .onComplete(() => {
                this.isFlipping = false;
                cb?.();
            })
            .start();
    }

}
